import React from "react";
import { Drawer, Box } from "@mui/material";
import InvoiceUploader from "../../../pages/purchaseInvoices/supplierInvoiceFiles/InvoiceUploader/invoiceUploader";

function FileUploadDrawer({ open, onClose }) {
  
  return (
    <Drawer 
      anchor="right" 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: 380, md: 420 },
          maxWidth: '100vw',
          background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 50%, #eff6ff 100%)'
        }
      }}
    >
      <Box sx={{ 
        width: '100%',
        height: '100%',
        overflow: 'auto'
      }}>
        <InvoiceUploader onClose={onClose} />
      </Box>
    </Drawer>
  );
}

export default FileUploadDrawer;